import { getPlayerAvailabilityUseCase } from '@/domain/use-cases/get-player-availabilty.use-case';
import { Result } from '@/entities';
import { PlayerAvailabilityDto } from '@/infrastructure/network/dto/playerAvailabilityDto';

export const getPlayerAvailabilityController = async (
	organizationUuid: string,
	teamLeagueUuid: string,
	playerId: string
): Promise<Result<PlayerAvailabilityDto[]>> => {
	return getPlayerAvailabilityUseCase(organizationUuid, teamLeagueUuid, playerId);
};
